
        <nav
            class="lg:hidden fixed inset-x-0 bottom-0 z-40 border-t border-[color:var(--border)] bg-[color:var(--card)] backdrop-blur shadow-[0_-14px_30px_rgba(15,23,42,0.08)]"
            aria-label="Dashboard navigation"
        >
            <div
                class="px-3 py-2 pb-[calc(env(safe-area-inset-bottom,0px)+0.5rem)]"
                [class.custom-scrollbar]="!useDistributedLayout"
                [class.overflow-x-auto]="!useDistributedLayout"
                [class.snap-x]="!useDistributedLayout"
                [class.snap-mandatory]="!useDistributedLayout"
            >
                <div
                    [class.flex]="!useDistributedLayout"
                    [class.w-max]="!useDistributedLayout"
                    [class.min-w-full]="!useDistributedLayout"
                    [class.items-stretch]="!useDistributedLayout"
                    [class.gap-2]="!useDistributedLayout"
                    [class.grid]="useDistributedLayout"
                    [class.w-full]="useDistributedLayout"
                    [class.gap-1]="useDistributedLayout"
                    [style.grid-template-columns]="useDistributedLayout ? distributedTemplateColumns : null"
                >
                    <a
                        *ngFor="let item of flatNavigation"
                        [routerLink]="item.href"
                        [attr.aria-label]="item.name"
                        [attr.title]="item.name"
                        [ngClass]="navActiveClasses(item.href)"
                        class="flex flex-col items-center justify-center gap-1 rounded-xl border border-transparent px-2 py-2 text-center text-[color:var(--muted-foreground)] transition-colors hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)]"
                        [class.w-[6.25rem]]="!useDistributedLayout"
                        [class.shrink-0]="!useDistributedLayout"
                        [class.snap-start]="!useDistributedLayout"
                        [class.w-full]="useDistributedLayout"
                    >
                        <lucide-icon [name]="item.icon" class="h-5 w-5"></lucide-icon>
                        <span class="max-w-full text-[10px] font-semibold leading-[1.15] whitespace-pre-line break-words">{{ item.mobileLabel }}</span>
                    </a>
                    <button
                        *ngIf="hasMore"
                        type="button"
                        (click)="toggleMore()"
                        aria-label="More"
                        class="flex flex-col items-center justify-center gap-1 rounded-xl border border-transparent px-2 py-2 text-center text-[color:var(--muted-foreground)] transition-colors hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)]"
                        [class.w-[6.25rem]]="!useDistributedLayout"
                        [class.shrink-0]="!useDistributedLayout"
                        [class.snap-start]="!useDistributedLayout"
                        [class.w-full]="useDistributedLayout"
                    >
                        <lucide-icon name="ellipsis" class="h-5 w-5"></lucide-icon>
                        <span class="max-w-full text-[10px] font-semibold leading-[1.15]">More</span>
                    </button>
                </div>
            </div>
        </nav>

        <div *ngIf="moreOpen" class="lg:hidden fixed inset-0 z-50">
            <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeMore()"></div>
            <div class="absolute inset-x-0 bottom-0 bg-[color:var(--card)] border-t border-[color:var(--border)] rounded-t-2xl p-4 pb-[calc(env(safe-area-inset-bottom,0px)+1rem)] shadow-[0_-14px_30px_rgba(15,23,42,0.18)]">
                <div class="flex items-center justify-between mb-4">
                    <p class="text-sm font-semibold text-[color:var(--foreground)]">More</p>
                    <button type="button" class="rounded-md p-1.5 text-[color:var(--text-subtle)] hover:bg-[color:var(--hover)] transition" (click)="closeMore()" aria-label="Close">
                        <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                    </button>
                </div>
                <div class="grid grid-cols-3 sm:grid-cols-4 gap-2 max-h-[60vh] overflow-y-auto custom-scrollbar">
                    <a
                        *ngFor="let item of moreItems"
                        [routerLink]="item.href"
                        (click)="closeMore()"
                        [attr.aria-label]="item.name"
                        class="flex flex-col items-center justify-center gap-1.5 rounded-xl border border-[color:var(--border)] bg-[color:var(--muted)] px-2 py-3 text-center text-[color:var(--muted-foreground)] transition-colors hover:bg-[color:var(--hover)] hover:text-[color:var(--primary)]"
                    >
                        <lucide-icon [name]="item.icon" class="h-5 w-5"></lucide-icon>
                        <span class="max-w-full text-[10px] font-semibold leading-[1.15] whitespace-pre-line break-words">{{ item.mobileLabel }}</span>
                    </a>
                </div>
            </div>
        </div>
